export const API_KEY = 'AIzaSyADRYcEBiV8UL-j1EXNyiaiGIl76CowJdg'